import Intercom from '@intercom/messenger-js-sdk'

export function initIntercom () {
  const appId = document.querySelector<HTMLMetaElement>('meta[name="intercom:app-id"]')?.content

  if (!appId) {
    return
  }

  const contextJwt = document.querySelector<HTMLMetaElement>('meta[name="intercom:context-jwt"]')?.content

  try {
    Intercom({
      app_id: appId,
      intercom_user_jwt: contextJwt,
    })
  } catch (error) {
    console.error('Failed to initialize Intercom:', error)
  }
}
